export default __webpack_public_path__ + "static/media/digna-tutorial-1.e68b1fc0.gif";